// extracted by mini-css-extract-plugin
module.exports = {"popoverTrigger":"Popover_popoverTrigger__p2FFB","popover":"Popover_popover__IPkhI","popoverArrow":"Popover_popoverArrow__iI4xZ"};